<script setup lang="ts">
/**
 * AnnouncementCard — mirrors .announce rows in resident-dashboard.html right rail.
 * No AI badge needed here (announcements are board-authored, not AI-generated).
 * Time uses font-mono tabular-nums per CLAUDE.md.
 */
import type { ResidentAnnouncementDto } from '@/composables/useResident';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

defineProps<{
  announcement: ResidentAnnouncementDto;
  eyebrow?: string;
}>();

function relTime(d: string): string {
  return dayjs(d).fromNow();
}
</script>

<template>
  <div class="announce" data-testid="announcement-card">
    <div class="announce-eyebrow">{{ eyebrow ?? 'Notice' }}</div>
    <div class="announce-title">{{ announcement.title }}</div>
    <div class="announce-body">{{ announcement.body }}</div>
    <div class="announce-meta font-mono tabular-nums">{{ relTime(announcement.publishedAt) }}</div>
  </div>
</template>

<style scoped>
.announce {
  padding: 14px 0;
  border-top: 1px solid var(--border);
}
.announce:first-of-type { border-top: 0; padding-top: 0; }
.announce-eyebrow {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--navy-700);
  margin-bottom: 4px;
}
.announce-title { font-size: 13.5px; font-weight: 600; margin-bottom: 4px; line-height: 1.4; }
.announce-body { font-size: 12.5px; color: var(--muted); line-height: 1.5; }
.announce-meta { font-size: 11.5px; color: var(--muted-2); margin-top: 6px; }
</style>
